import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { GamesState } from './types'
import { filterParlayMiniGames, sortGamesByType } from './utils'

const initialState: GamesState = {
  allGames: [],
  loading: false,
  gamesByCategory: null,
}

export const gamesSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    saveGameProducts: (state, action: PayloadAction<{ games: Array<GameProduct> }>) => {
      const filteredGames = filterParlayMiniGames(action.payload.games)
      const sortedGames = sortGamesByType(filteredGames)
      state.gamesByCategory = sortedGames
    },
    saveAllGames: (state, action: PayloadAction<GameProduct[]>) => {
      state.allGames = filterParlayMiniGames(action.payload)
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof gamesSlice.actions>>
export const { actions } = gamesSlice
